import React from "react";
import { onESignActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import ESignActivityCard from "./ESignActivityCard";
interface Props {
  documentId: number
  config: server.dto.ActivityPanelConfig
}

const ESignActivityPanel = (props: Props) => {
  const pageLoadCausingESignActions: server.dto.ESignActions[] = [
    "lifeCycleToDraft",
    "lifeCycleToReview",
    "lifeCycleToOutForSignature",
    "lifeCycleToCompleted",
    "lifeCycleToDiscarded",
    "manualComplete"
  ];

  return <ActivityPanel<server.dto.ESignActivity>
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.ESign.ListActivity({ itemId: props.documentId, page, perPage })}
    renderActivity={(activity) => <ESignActivityCard key={activity.activityId} activity={activity} />}
    onActivityRegisterFn={onESignActivity}
    onActivity={(activity) => {
      if (activity.itemId !== props.documentId) return { refreshActivities: false };

      const iAmActor = (activity.actor?.userId === site.currentUser.userId);

      if ((iAmActor) && pageLoadCausingESignActions.includes(activity.action.value)) return { refreshActivities: false };

      return { refreshActivities: true };
    }}
  />;
};

export default ESignActivityPanel;